module.exports = __webpack_public_path__ + "img/banner.bf596017.png";